import axios from 'axios'
import store from '@/store'

const savitarna = window.location.host === process.env.VUE_APP_SAVITARNA_HOST

// create axios
const service = axios.create({
  baseURL: savitarna
    ? process.env.VUE_APP_SAVITARNA_BASE_API
    : process.env.VUE_APP_BASE_API,
  timeout: 50000,
})

const err = (error) => {
  const { status, data } = error.response
  const { errors } = data
  let message = []
  for (let field in errors) {
    message.push(errors[field])
  }
  switch (status) {
    case 400:
      this.$root.$emit('SHOW_SNACKBAR', {
        show: true,
        text: 'Bad Request ' + data.message,
        color: 'red',
      })
      break

    case 422:
      this.$root.$emit('SHOW_SNACKBAR', {
        show: true,
        text: message,
        color: 'red',
      })
      break

    case 403:
      this.$root.$emit('ACESS_DENIED')
      break
    case 404:
      this.$root.$emit('DATA_ERROR')
      break
    case 500:
      this.$root.$emit('SERVER_ERROR')
      break

    default:
      break
  }

  return Promise.reject(error)
}

// request interceptor

service.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json'
  config.headers['Authorization'] = 'Bearer ' + store.getters.getAccessToken

  return config
}, err)

// response interceptor

service.interceptors.response.use(({ data, config }) => {
  if (['put', 'post', 'delete', 'patch'].includes(config.method) && data.meta) {
    this.$root.$emit('SHOW_SNACKBAR', {
      text: data.meta.message,
      color: 'success',
    })
  }
  if (data.error !== undefined) {
    this.$root.$emit('API_FAILED', data.error)
  }

  return data
}, err)

export default service
